import React from 'react';
import ResourceUtil from './ResourceUtil';
const STRINGS = {};
const reverseEscapeRegex = new RegExp(":(?!\/)");
const LangUtil = {
  reversemap: {},
  add(langMap) {
    return new Promise((resolve) => {
      for (var key in langMap.map) {
        STRINGS[key.toLowerCase()] = langMap.map[key];
      }
      resolve(langMap);
    })
  },
  loadLangJson(fileNameJson) {
    var self = this;
    return ResourceUtil.getJSON(fileNameJson).then(function(resp) {
      return self.add(resp);
    });
  },
  reverseStr : str => str.split("").reduce((acc, currVal) => currVal + acc, ""),
  getEscapedKeys(key) {
    let escapedKeys = [];
    let revKeyStr = this.reverseStr(key);
    let revKeyStrArr = revKeyStr.split(reverseEscapeRegex);
    revKeyStrArr.map(v => {
      escapedKeys.unshift(this.reverseStr(v).replace(/\/:/g, ":")) //replace all /: with :
    })
    return escapedKeys;
  },
  getVal(key,tnt) {
    if (typeof key === 'string') {
      //let escape = new RegExp("(?<!\/):")
      var keys = key.split(":");
      if(key.indexOf("/:") !== -1) keys = this.getEscapedKeys(key);
      var str = STRINGS[keys[0].toLowerCase()] || "";
      let replaceCount = (str.match(/\$/g) || []).length;
      for (var i = 1; i <= replaceCount; i++) { // <= replaceCount instead of < keys.length
        str = str.replace(new RegExp(`\\$${i}`, "g") , keys[i] || "");
      }
      var vars = (str.match(/\$\{[\w]+\}/gm) || []).map(function(strkey){
          return strkey.replace("${","").replace("}","")
        });
      tnt = (tnt || "def").toLowerCase();
      for(var ivar in vars){
        str = str.replace("${" + vars[ivar] + "}", (STRINGS["var."+vars[ivar]+"." + tnt] || STRINGS["var."+vars[ivar]+".def"] || ""));
      }
      str = str ? str : key;
      if (this.reversemap) {
        this.reversemap[str] = key;
      }
      return str;
    }
    return key;
  },
  getMsg(msgKey, tnt){
    let key = msgKey.split("_").join("").toLowerCase();
    let args = msgKey.split(":");
    args.shift();
    let fullKey = `g.msg.${key.split(":")[0]}:${args.join(":")}`;
    let msg = this.getVal(fullKey, tnt);
    if(msg === fullKey) return msgKey;

    return msg;
  },
  key(str) {
    if (typeof str === 'string' && this.reversemap && this.reversemap[str]) {
      return this.reversemap[str];
    }
    return str;
  }
};

const I18n = (key,tnt) => LangUtil.getVal(key,tnt);
const langFloat = () => LangUtil.getVal('langFloat');

export default LangUtil;
export {I18n, langFloat};
